import type { StateOverride } from "viem"

interface StorageMapping {
  key: string
  value: string
}

export interface TenderlyStateOverride {
  contractAddress: string
  balance?: string
  storage?: StorageMapping[]
  open?: boolean
}

export function generateTenderlySimulatorUrl(
  account: string,
  to: string,
  data: string,
  stateOverride: TenderlyStateOverride[],
  chainId: number,
) {
  const tenderlySimulatorUrl = localStorage.getItem("tenderlySimulatorUrl")
  if (!tenderlySimulatorUrl) {
    throw new Error("Tenderly simulator URL not found")
  }
  const baseUrl = tenderlySimulatorUrl
  const queryParams = new URLSearchParams({
    network: chainId.toString(),
    block: "",
    blockIndex: "0",
    from: account,
    gas: "8000000",
    gasPrice: "0",
    value: "0",
    contractAddress: to,
    rawFunctionInput: data,
    stateOverrides: JSON.stringify(stateOverride),
    headerBlockNumber: "",
    headerTimestamp: "",
  })
  return `${baseUrl}?${queryParams.toString()}`
}

export function convertStateOverrideToTenderlyStateOverride(
  stateOverride: StateOverride | undefined,
) {
  if (!stateOverride) {
    return []
  }
  const tenderlyOverrides: TenderlyStateOverride[] = []
  for (let index = 0; index < stateOverride.length; index++) {
    const override = stateOverride[index]
    const stateDiff = override?.stateDiff
    const tenderlyStateMapping: StorageMapping[] = []
    if (stateDiff) {
      for (let index = 0; index < stateDiff.length; index++) {
        const element = stateDiff[index]
        if (!element) {
          continue
        }
        tenderlyStateMapping.push({
          key: element.slot,
          value: element.value,
        })
      }
    }
    if (!override) {
      continue
    }
    const tenderlyOverride: TenderlyStateOverride = {
      contractAddress: override.address,
      balance: override.balance?.toString() || "",
      storage: tenderlyStateMapping,
      open: true,
    }
    tenderlyOverrides.push(tenderlyOverride)
  }
  return tenderlyOverrides
}
